/**
 * This function is very simple: it just creates a new AbortController.
 * We have this function so that we can mock AbortController in our jest tests,
 * because jsdom/jest doesn't really do a good job of polyfilling it.
 * @see frontend/js/tests/libs/mock-create-abort-controller.ts
 * @returns {AbortController}
 */
export function createAbortController() {
    return new AbortController();
}
